import { ADD_API_KEY } from "./action-types";

// Add API action
export const addApiKey = (api) => ({
    type: ADD_API_KEY,
    payload: api
});